import {
  DialogDescription,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogClose,
  Dialog,
  Button,
} from '@ui/components';
import { useTranslation } from 'react-i18next';

import { useRemoveEmployeeProfileDialog } from './use-remove-employee-profile-dialog';

interface RemoveEmployeeProfileDialogProps {
  onClose: ({ handleSubmit }: { handleSubmit: boolean }) => void;
  isOpen: boolean;
  id: string;
}

export const RemoveEmployeeProfileDialog = ({
  onClose,
  isOpen,
  id,
}: RemoveEmployeeProfileDialogProps) => {
  const { removeProfile, isPending } = useRemoveEmployeeProfileDialog(() =>
    onClose({ handleSubmit: true }),
  );

  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={() => onClose({ handleSubmit: false })} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('EMPLOYEE_PROFILES.REMOVE_EMPLOYEE_PROFILE.DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {t('EMPLOYEE_PROFILES.REMOVE_EMPLOYEE_PROFILE.DIALOG_DESCRIPTION')}
        </DialogDescription>
        <DialogFooter className="flex items-center justify-between gap-4">
          <DialogClose asChild>
            <Button variant="tertiary" wide>
              {t('EMPLOYEE_PROFILES.REMOVE_EMPLOYEE_PROFILE.DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            onClick={() => isOpen && removeProfile(id)}
            isLoading={isPending}
            variant="primary"
            wide
          >
            {t('EMPLOYEE_PROFILES.REMOVE_EMPLOYEE_PROFILE.DIALOG_DELETE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
